// E-Learning Module Routes
export default [
  {
    path: '/reports/e-learning',
    name: 'elearning-reports',
    component: () => import('@/views/reports/elearning-catalogue.vue'),
    meta: { authRequired: true, title: 'E-Learning Reports', privileges: ['VIEW_E_LEARNING_DASHBOARD'] }
  },
  {
    path: '/reports/e-learning/:reportCode',
    name: 'elearning-report-runner',
    component: () => import('@/views/reports/elearning-report-runner.vue'),
    meta: { authRequired: true, title: 'E-Learning Report', privileges: ['VIEW_E_LEARNING_DASHBOARD'] }
  },
  {
    path: '/elearning',
    name: 'elearning',
    redirect: '/elearning/dashboard',
    meta: {
      authRequired: true,
      title: 'E-Learning Management',
      privileges: [
        'VIEW_E_LEARNING_DASHBOARD'
      ]
    }
  },
  {
    path: '/elearning/dashboard',
    name: 'elearning-dashboard',
    component: () => import('@/views/elearning/dashboard.vue'),
    meta: {
      authRequired: true,
      title: 'E-Learning Dashboard',
      breadcrumb: [
        {text: 'Dashboard', to: '/dashboard'},
        {text: 'E-Learning', active: true}
      ],
      privileges: [
        'VIEW_E_LEARNING_DASHBOARD'
      ]
    }
  },
  {
    path: '/elearning/courses',
    name: 'courses',
    component: () => import('@/views/elearning/courses.vue'),
    meta: {
      authRequired: true,
      title: 'Course Management',
      privileges: [
        'VIEW_COURSE_ENTRIES'
      ]
    }
  },
  {
    path: '/elearning/modules',
    name: 'modules',
    component: () => import('@/views/elearning/modules.vue'),
    meta: {
      authRequired: true,
      title: 'Module Management',
      privileges: [
        'VIEW_MODULE_ENTRIES'
      ]
    }
  },
  {
    path: '/elearning/modules/:moduleId/lessons',
    name: 'lessons',
    component: () => import('@/views/elearning/lessons.vue'),
    meta: {
      authRequired: true,
      title: 'Lesson Management',
      privileges: [
        'VIEW_LESSON_ENTRIES'
      ]
    }
  },
  {
    path: '/elearning/grading/queue',
    name: 'grading-queue',
    component: () => import('@/views/elearning/grading-queue.vue'),
    meta: {
      authRequired: true,
      title: 'Manual Grading Queue',
      privileges: [
        'VIEW_ASSESSMENT_ENTRIES'
      ]
    }
  },
  {
    path: '/elearning/grading/attempt/:id',
    name: 'grade-attempt',
    component: () => import('@/views/elearning/grade-attempt.vue'),
    meta: {
      authRequired: true,
      title: 'Grade Attempt',
      privileges: [
        'VIEW_ASSESSMENT_ENTRIES'
      ]
    }
  },
  {
    path: '/elearning/modules/:id/content',
    name: 'module-content',
    component: () => import('@/views/elearning/module-content.vue'),
    meta: {
      authRequired: true,
      title: 'Module Content Management',
      privileges: [
        'EDIT_MODULE'
      ]
    }
  },
  {
    path: '/elearning/approve-module',
    name: 'approve-module',
    component: () => import('@/views/elearning/approve-module.vue'),
    meta: {
      authRequired: true,
      title: 'Approve Module',
      privileges: [
        'APPROVE_MODULE'
      ]
    }
  },
  {
    path: "/elearning/manage-course",
    name: "manage-course",
    meta: {
      title: "Manage Course",
      authRequired: true,
      privileges: [
        'SUBMIT_COURSE',
        'EDIT_COURSE'
      ]
    },
    component: () => import("../views/elearning/manage-course.vue"),
  },
  {
    path: "/elearning/course-management-center",
    name: "course-management-center",
    meta: {
      title: "Course Manager",
      authRequired: true,
      privileges: [
        'SUBMIT_COURSE',
        'EDIT_COURSE'
      ]
    },
    component: () => import("../views/elearning/course-management-center.vue"),
  },
  {
    path: "/elearning/manage-topic",
    name: "manage-topic",
    meta: {
      title: "e-Library Manage Topic",
      authRequired: true,
      privileges: [
        'SUBMIT_TOPIC',
        'EDIT_TOPIC'
      ]
    },
    component: () => import("../views/elearning/manage-topic.vue"),
  },
  {
    path: "/elearning/duplicate-topic/:id",
    name: "duplicate-topic",
    meta: {
      title: "e-Library Manage Topic",
      authRequired: true,
      privileges: [
        'SUBMIT_TOPIC',
        'EDIT_TOPIC'
      ]
    },
    component: () => import("../views/elearning/manage-topic.vue"),
  },
  {
    path: "/elearning/topics",
    name: "elearning-topics",
    meta: {
      title: "e-Library topics",
      authRequired: true,
      privileges: [
        'VIEW_TOPIC_ENTRIES'
      ]

    },
    component: () => import("../views/elearning/topics.vue"),
  },
  {
    path: "/elearning/view-frequently-asked-question",
    name: "view-faq",
    meta: {
      title: "e-Library View Frequently Asked Question",
      authRequired: true,
      privileges: [
        'SUBMIT_FAQ',
        'EDIT_FAQ',
      ]
    },
    component: () => import("../views/elearning/manage-faq.vue"),
  },
  {
    path: "/elearning/manage-frequently-asked-question",
    name: "manage-faq",
    meta: {
      title: "e-Library Manage Frequently Asked Question",
      authRequired: true,
      privileges: [
        'SUBMIT_FAQ',
        'EDIT_FAQ',
      ]
    },
    component: () => import("../views/elearning/manage-faq.vue"),
  },
  {
    path: "/elearning/duplicate-frequently-asked-question/:id",
    name: "duplicate-faq",
    meta: {
      title: "e-Library Duplicate Frequently Asked Question",
      authRequired: true,
      privileges: [
        'SUBMIT_FAQ',
        'EDIT_FAQ',
      ]
    },
    component: () => import("../views/elearning/manage-faq.vue"),
  },
  {
    path: "/elearning/frequently-asked-questions",
    name: "faqs",
    meta: {
      title: "e-Library Frequently Asked Questions",
      authRequired: true,
      privileges: [
          'VIEW_FAQ_ENTRIES'
      ]
    },
    component: () => import("../views/elearning/faqs.vue"),
  },
  {
    path: "/elearning/resources",
    name: "elearning-resources",
    meta: {
      title: "e-Library Resources",
      authRequired: true,
      privileges: [
          'VIEW_RESOURCE_ENTRIES'
      ]
    },
    component: () => import("../views/elearning/resources.vue"),
  },
  {
    path: "/elearning/manage-resource",
    name: "manage-content",
    meta: {
      title: "e-Library Manage Resources",
      authRequired: true,
      privileges: [
        'SUBMIT_RESOURCE',
        'EDIT_RESOURCE',
      ]
    },
    component: () => import("../views/elearning/manage-resource.vue"),
  },
  {
    path: "/elearning/approve-resource",
    name: "approve-resource",
    meta: {
      title: "e-Library Approve Resources",
      authRequired: true,
      privileges: [
        'SUBMIT_RESOURCE',
        'EDIT_RESOURCE',
      ]
    },
    component: () => import("../views/elearning/approve-resource.vue"),
  },
  {
    path: "/elearning/approve-faq",
    name: "approve-faq",
    meta: {
      title: "Approve FAQ",
      authRequired: true,
      privileges: [
        'APPROVE_FAQ',
        'REVIEW_FAQ'
      ]
    },
    component: () => import("../views/elearning/approve-faq.vue"),
  },
  {
    path: "/elearning/approve-topic",
    name: "approve-topic",
    meta: {
      title: "Approve Topic",
      authRequired: true,
      privileges: [
        'APPROVE_TOPIC',
        'REVIEW_TOPIC'
      ]
    },
    component: () => import("../views/elearning/approve-topic.vue"),
  },
  {
    path: '/elearning/courses/view/:id',
    name: 'view-course',
    meta: {
      authRequired: true,
      title: 'View Course',
      privileges: [
        'VIEW_LESSON_ENTRIES'
      ]
    },
    component: () => import('@/views/elearning/course-student-view.vue'),
  },

  // Student Learning Routes
  {
    path: '/elearning/students/dashboard',
    name: 'student-dashboard',
    meta: {
      authRequired: true,
      title: 'Student Dashboard',
      breadcrumb: [
        {text: 'Dashboard', to: '/dashboard'},
        {text: 'E-Learning', to: '/elearning'},
        {text: 'Student Dashboard', active: true}
      ],
      privileges: [
        // 'ACCESS_STUDENT_LEARNING'
      ]
    },
    component: () => import('@/views/elearning/students/student-dashboard.vue'),
  },
  {
    path: '/elearning/students/browse-courses',
    name: 'browse-courses',
    meta: {
      authRequired: true,
      title: 'Browse Courses',
      breadcrumb: [
        {text: 'Dashboard', to: '/dashboard'},
        {text: 'E-Learning', to: '/elearning'},
        {text: 'Browse Courses', active: true}
      ],
      privileges: [
        // 'ACCESS_STUDENT_LEARNING'
      ]
    },
    component: () => import('@/views/elearning/students/browse-courses.vue'),
  },
  {
    path: '/elearning/students/my-courses',
    name: 'my-courses',
    meta: {
      authRequired: true,
      title: 'My Courses',
      breadcrumb: [
        {text: 'Dashboard', to: '/dashboard'},
        {text: 'E-Learning', to: '/elearning'},
        {text: 'My Courses', active: true}
      ],
      privileges: [
        // 'ACCESS_STUDENT_LEARNING'
      ]
    },
    component: () => import('@/views/elearning/students/my-courses.vue'),
  },
  {
    path: '/elearning/students/lesson-learning',
    name: 'lesson-learning',
    meta: {
      authRequired: true,
      title: 'Continue Learning',
      breadcrumb: [
        {text: 'Dashboard', to: '/dashboard'},
        {text: 'E-Learning', to: '/elearning'},
        {text: 'Continue Learning', active: true}
      ],
      privileges: [
        // 'ACCESS_STUDENT_LEARNING'
      ]
    },
    component: () => import('@/views/elearning/students/lesson-learning.vue'),
  },
  {
    path: '/elearning/students/course/:id',
    name: 'course-student-view',
    meta: {
      authRequired: true,
      title: 'Course View',
      breadcrumb: [
        {text: 'Dashboard', to: '/dashboard'},
        {text: 'E-Learning', to: '/elearning'},
        {text: 'Course', active: true}
      ],
      privileges: [
        // 'ACCESS_STUDENT_LEARNING'
      ]
    },
    component: () => import('@/views/elearning/course-student-view.vue'),
  },
  {
    path: '/elearning/lessons/view/:id',
    name: 'view-lesson',
    component: () => import('@/views/elearning/view-lesson.vue'),
    meta: {
      authRequired: true,
      title: 'View Lesson',
      privileges: [
        'VIEW_LESSON_ENTRIES'
      ]
    }
  },
  {
    path: '/elearning/assessments/view/:id',
    name: 'view-assessment',
    component: () => import('@/views/elearning/view-assessment.vue'),
    meta: {
      authRequired: true,
      title: 'View Assessment',
      privileges: [
        'VIEW_ASSESSMENT_ENTRIES'
      ]
    }
  },
]
